import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const inst = axios.create({ baseURL: API });

inst.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sakshi_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

inst.interceptors.response.use(
  (r) => r,
  (err) => {
    try {
      if (err?.response?.status === 401) {
        localStorage.removeItem("sakshi_token");
        localStorage.removeItem("sakshi_user");
        if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
      }
    } catch (e) {
      console.warn("api response interceptor error", e);
    }
    return Promise.reject(err);
  }
);

export default inst;
